module.exports = __webpack_public_path__ + "img/christmas-gallery-1.eeebfc11.jpg";